import {
  CommandCenterSidebar,
  SIDEBAR_WIDTH_CLASS,
} from './CommandCenterSidebar';
import { NowTab } from './NowTab';

/**
 * The manager command center - the recurring home after onboarding. Built fresh
 * (no app chrome), it answers a single question: *what do I handle right now?*.
 * The "Now" tab is pattern-led triage; the project deep dives live one click
 * away in the left rail.
 */
export function ManagerCommandCenter() {
  return (
    <div className="relative min-h-[100dvh] overflow-hidden bg-[linear-gradient(180deg,#ffffff_0%,#f8fafc_60%,#f3f6fb_100%)] text-black">
      {/* A faint alert glow bleeding from the top edge - ambient pressure, not decoration. */}
      <div className="pointer-events-none absolute inset-x-0 -top-24 h-72 bg-[radial-gradient(58%_100%_at_50%_0%,rgba(244,63,94,0.12),transparent_72%)]" />

      <CommandCenterSidebar activeTab="now" />
      <div className={SIDEBAR_WIDTH_CLASS}>
        <main className="relative z-10">
          <NowTab />
        </main>
      </div>
    </div>
  );
}
